import {post, get} from '@/utils/request'

// 提现申请统计
export function getTotalCount(data) {
    return post({
        data,
        url: '!Busi/Financial/Withdraw/~java/Withdraw.getTotalCount'
    })
}
// 校验提现时刻余额
export function checkBalance(data) {
    return post({
        data,
        url: '!Busi/Financial/Withdraw/~java/Withdraw.checkBalance'
    })
}

// 工单审核
export function handleWalletOrder(data) {
    return post({
        data,
        url: '!Busi/Financial/Withdraw/~java/Withdraw.handleWalletOrder'
    })
}

// 获取用户收支流水明细表
export function getWalletLogs(data) {
    return post({
        data,
        url: '!Busi/Financial/Withdraw/~query/Q_WITHDRAW.Q_WALLET_LOGS'
    })
}

// 更新工单
export function updateMallWalletOrder(data) {
    return post({
        data,
        url: '!Busi/Financial/Withdraw/~java/Withdraw.updateMallWalletOrder'
    })
}

// 随机获取一个待审核工单
export function getRandomAppliedOrder(data) {
    return post({
        data,
        url: '!Busi/Financial/Withdraw/~java/Withdraw.getRandomAppliedOrder'
    })
}

// 历史审核明细
export function getHisReviewDetails(data) {
  return post({
    data,
    url: '!Busi/Financial/Withdraw/~java/Withdraw.getReviewDetails'
  })
}

// 获取已提现的统计数据
export function getPassedCount(data) {
  return post({
    data,
    url: '!Busi/Financial/Withdraw/~java/Withdraw.getPassedCount'
  })
}

// 获取已通过审核的账单明细
export function getPassedOrderDetails(data) {
  return post({
    data,
    url: '!Busi/Financial/Withdraw/~java/Withdraw.getBillDetails'
  })
}
